import { css } from "@emotion/react";

export type EpisodeItemProps = {
  episode: number;
  title: string;
  imgPaths: string[];
  description: string;
};

export const EpisodeItem: React.FC<EpisodeItemProps> = ({
  episode,
  title,
  imgPaths,
  description,
}) => {
  return (
    <div css={episodeItemStyle}>
      <div css={episodeTitleWrapperStyle}>
        <span css={myFontstyle}>
          Episode {episode}
          {episode !== 6 && "　"}
        </span>
        <span css={notoFontStyle}>{title}</span>
      </div>
      <div css={episodeItemImgContainerStyle}>
        {imgPaths.map((imgPath, idx) => (
          <img
            key={"episode" + episode + "-" + "img" + idx}
            src={process.env.REACT_APP_ASSET_BASE_PATH + imgPath}
            css={episodeItemImgStyle}
            alt="episode-img"
          />
        ))}
      </div>
      <div css={episodeItemDescriptionStyle}>{description}</div>
    </div>
  );
};

const contentsMaxWidth = 750;
const spSize = 768;

const episodeItemStyle = css`
  max-width: ${contentsMaxWidth}px;
  width: 85%;
  margin-bottom: 20px;
`;

const episodeTitleWrapperStyle = css`
  margin-bottom: 10px;
  font-size: 23px;
  line-height: 36px;
  display: flex;
  align-items: center;

  @media (max-width: ${spSize}px) {
    font-size: 14px;
    line-height: 28px;
  }
`;

const myFontstyle = css`
  font-family: MyFont;
`;

const notoFontStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-weight: bold;
`;

const episodeItemImgContainerStyle = css`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const episodeItemImgStyle = css`
  width: 30%;
  height: auto;
`;

const episodeItemDescriptionStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 15px;
  font-weight: bold;
  text-align: left;

  @media (max-width: ${spSize}px) {
    font-size: 10px;
  }
`;

export default EpisodeItem;
